import { defineMessages } from 'react-intl';

export default defineMessages({
    submitTitleGL:{
        // eslint-disable-next-line no-secrets/no-secrets
        "id":"payrollreporting.requestchange.reviewMEL.Certify Payroll",
        "defaultMessage":"Certify Payroll"
    },
    PEsubmitMessageGL:{
        "id":"PEpayrollreporting.reviewMEL.I certify that the payroll figures appearing in this report are a true and correct statement of all the earnings by all employees of the insured for the period stated. I further certify that I have been authorized by the insured to submit this information on its behalf.",
        "defaultMessage":"I certify that the payroll figures appearing in this report are a true and correct statement of all the earnings by all employees of the insured for the period stated. I further certify that I have been authorized by the insured to submit this information on its behalf."
    },
    submitMessageGL:{
        "id":"payrollreporting.reviewMELine.AI certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated",
        "defaultMessage":"I certify that payroll figures appearing in this report are true and a complete statement of all the earnings by all of our employees for the period stated."
    },

});